/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BookingStatus = {
    Pending: 'Pending',
    Booked: 'Booked',
    Cancelled: 'Cancelled',
    Rejected: 'Rejected'
} as const;
export type BookingStatus = typeof BookingStatus[keyof typeof BookingStatus];


export function instanceOfBookingStatus(value: any): boolean {
    for (const key in BookingStatus) {
        if (Object.prototype.hasOwnProperty.call(BookingStatus, key)) {
            if (BookingStatus[key as keyof typeof BookingStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingStatusFromJSON(json: any): BookingStatus {
    return BookingStatusFromJSONTyped(json, false);
}

export function BookingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingStatus {
    return json as BookingStatus;
}

export function BookingStatusToJSON(value?: BookingStatus | null): any {
    return value as any;
}

export function BookingStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingStatus {
    return value as BookingStatus;
}

